var React = require('react');

function ArrowLeftRegular (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"arrow-left-regular","d":"M12.83,59.1l1.1-1.1a.67.67,0,0,0,0-.947L5.278,48.393H24.331a.67.67,0,0,0,.67-.67V46.161a.67.67,0,0,0-.67-.67H5.278l8.657-8.657a.67.67,0,0,0,0-.947l-1.1-1.1a.67.67,0,0,0-.947,0L.2,46.469a.67.67,0,0,0,0,.947L11.883,59.1A.67.67,0,0,0,12.83,59.1Z","transform":"translate(0 -34.587)"}));
}

ArrowLeftRegular.defaultProps = {"width":"25.29","height":"25","viewBox":"0 0 25.29 25"};

module.exports = ArrowLeftRegular;

ArrowLeftRegular.default = ArrowLeftRegular;
